import { Navigate } from 'react-router-dom'
import type { ModuleConfig } from '../../config/moduleRegistry'
import { useModuleFlagGate } from '../../hooks/shared/useModuleFlagGate'

interface ModuleFlagGuardProps {
  module: ModuleConfig
  children: React.ReactNode
}

/** Route-level counterpart of the Sidebar/Home `featureFlag` filter. */
export default function ModuleFlagGuard({ module, children }: ModuleFlagGuardProps) {
  const { isModuleFlagOpen, isLoading } = useModuleFlagGate()

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#FF5A00]"></div>
      </div>
    )
  }

  if (!isModuleFlagOpen(module)) {
    return <Navigate to="/unauthorized" replace />
  }

  return <>{children}</>
}
